import { memo } from 'react';
import { SwitchCase } from '@toss/react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { WithPlanBadge } from '@/shared/components/Badge/PlanBadge';
import { useUserPlanManager } from '@/shared/plan';
import { useUpsellingGuard } from '@/shared/plan/useUpsellingGuard';
import { Drawer as DrawerRoot, DrawerOverlay, DrawerPortal } from '@/ui_v3';
import { cn } from '@/utils';
import { Header } from './Header';
import { MobileTrigger } from './MobileTrigger';
import { Pending } from './Pending';
import { SimilarQuizPrompt } from './SimilarQuizPrompt';
import { Success } from './Success';
import { type AiGenerateSimilarQuizModalProps } from './type';
export const Drawer = memo((props: AiGenerateSimilarQuizModalProps) => {
  const {
    disabled,
    isOpen,
    onOpen,
    onClose,
    className,
    prompt,
    items,
    onRetry,
    status,
    promptPresets,
    onGetPromptPresets,
    onGenerate,
    previousPrompt,
    onDelete
  } = props;
  const {
    userPlanManager
  } = useUserPlanManager();
  const featurePlanType = userPlanManager.getFeaturePlanType('AI_SIMILAR_QUIZ_GENERATION');
  const upsellingGuard = useUpsellingGuard();
  return <DrawerRoot open={isOpen}>
      <WithPlanBadge isBadgeVisible={true} planType={featurePlanType}>
        <MobileTrigger disabled={disabled} onClick={() => upsellingGuard(() => onOpen(), {
        feature: 'AI_SIMILAR_QUIZ_GENERATION',
        from: 'ai'
      })} className={className} />
      </WithPlanBadge>
      <DrawerPortal>
        <DrawerOverlay />
        <DrawerPrimitive.Content className={cn('shadow-xl fixed bottom-0 z-modal mt-24 flex h-auto flex-col rounded-t-[10px] border bg-white', '!max-h-[calc(90%-env(safe-area-inset-top))] overflow-hidden', 'w-full mobile-lg:w-[720px]', 'h-[750px]')}>
          <Header onClose={onClose} />
          <SwitchCase value={status} caseBy={{
          pending: <Pending prompt={prompt} />,
          success: <Success items={items} onRetry={onRetry} onClose={onClose} onDelete={onDelete} />
        }} defaultComponent={<SimilarQuizPrompt onMount={onGetPromptPresets} onGenerate={onGenerate} onCancel={onClose} previousPrompt={previousPrompt} promptPresets={promptPresets} />} />
        </DrawerPrimitive.Content>
      </DrawerPortal>
    </DrawerRoot>;
});